import api from 'api'

export const removeForm = async (id) => {
  const { data } = await api.delete(`/form/${id}`)

  return data
}
